import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#141329',
        padding: '72px 0',
        [theme.breakpoints.up('md')]: {
            // Background gradient anchored to viewport left edge regardless of
            // where the phone image lands inside ctnImage.
            backgroundImage: `url('/static/new-landing-page/why-myfitsociety/background_gradient_why_myfitsociety.webp')`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'left center',
            backgroundSize: 'auto 100%',
        },
        [theme.breakpoints.down('md')]: {
            padding: '40px 0',
            paddingTop: 0,
            marginTop: -4
        },
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
        }
    },
    ctnImage: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',

        [theme.breakpoints.down('md')]: {
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
        },
        [theme.breakpoints.up('md')]: {
            minHeight: 490,
            // Mirror WorkoutPlan ctnLeft pattern (50% width + marginLeft 96 +
            // flex-end) so phone image aligns with /Discover title row below.
            justifyContent: 'flex-end',
            marginLeft: 96,
        }
    },
    ctnImageWrapper: {
        // Reserve fixed slot so slide swap doesn't shift layout below
        [theme.breakpoints.up('md')]: {
            minHeight: 490,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
        },
        [theme.breakpoints.down('md')]: {
            width: '100%',
            minHeight: '90vw',
            maxHeight: 480,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        '& > img': {
            objectFit: 'contain',
            [theme.breakpoints.up('md')]: {
                width: 'auto',
                maxWidth: 360,
                height: 490,
                paddingLeft: 0,
                marginLeft: 0,
            },
            [theme.breakpoints.down('md')]: {
                width: '100%',
                height: '100%',
                paddingRight: 0,
            },
        },
        [theme.breakpoints.up('lg')]: {
            minWidth: 540,
        },
    },
    ctnContent: {
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        [theme.breakpoints.up('md')]: {
            paddingRight: 96,
        },
        [theme.breakpoints.down('md')]: {
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: 32,
            padding: '0 24px',
        },
        [theme.breakpoints.down('sm')]: {
            '& > button': {
                width: '100%',
            }
        }
    },
    title: {
        marginTop: 0,
        fontSize: 48,
        fontWeight: 800,
        color: '#fff',
        lineHeight: '56px',
        marginBottom: 32,
        [theme.breakpoints.down('md')]: {
            marginBottom: '24px',
            fontSize: 32,
            lineHeight: '36px',
        },
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
        },
    },
    ctnChecklist: {
        marginBottom: 24,
        [theme.breakpoints.up('md')]: {
            marginBottom: 34,
        }
    }
}));

export default useStyles;